// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileAppsBlock__container-d8bc89 .MobileAppsBlock__list-eb1262 {
  padding: 8px 0;
}

.MobileAppsBlock__divider-e36385 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  padding: 8px 0;
  margin-bottom: 24px;
}

.MobileAppsBlock__divider-text-a1d1e5 {
  white-space: nowrap;
}

.MobileAppsBlock__divider-e36385::after,
.MobileAppsBlock__divider-e36385::before {
  content: "";
  flex: 1;
  height: 1px;
  width: 100%;
  background-color: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/pages/deepLink/MobileAppsBlock/MobileAppsBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;AACF","sourcesContent":[".container .list {\n  padding: 8px 0;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  padding: 8px 0;\n  margin-bottom: 24px;\n}\n\n.divider-text {\n  white-space: nowrap;\n}\n\n.divider::after,\n.divider::before {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  width: 100%;\n  background-color: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileAppsBlock__container-d8bc89`,
	"list": `MobileAppsBlock__list-eb1262`,
	"divider": `MobileAppsBlock__divider-e36385`,
	"divider-text": `MobileAppsBlock__divider-text-a1d1e5`,
	"dividerText": `MobileAppsBlock__divider-text-a1d1e5`
};
module.exports = ___CSS_LOADER_EXPORT___;
